import React from "react";
import { useState, useEffect } from 'react';
import { uf_addTimeStr } from '../../modules/utils.mjs'

import '../../index.css';

const BrokerTable = ({
    serial,
    data,
    updateTable,
    mqttReq
}) => {
    const [tableBrokerState, setTableBrokerState] = useState([]);

    const [indirizzoState, setIndirizzoState] = useState('')
    const [utenteState, setUtenteState] = useState('')
    const [passwordState, setPasswordState] = useState('')
    const [updateBrokerTableState, setUpdateBrokerTableState] = useState('')
    const handleIndirizzoChange = (event) => { setIndirizzoState(event.target.value) }
    const handleUtenteChange = (event) => { setUtenteState(event.target.value) }
    const handlePasswordChange = (event) => { setPasswordState(event.target.value) }

    const [includeHost, setIncludeHost] = useState(false);
    const [includeUser, setIncludeUser] = useState(false);
    const [includePwd, setIncludePwd] = useState(false);

    useEffect(() => {
        if ((data !== null) && (data !== undefined))
            uf_addTimeStr(data)
        setTableBrokerState(data)
    }, [data]);

    function prepareupdatebrokertable() {
        if (tableBrokerState?.host != null) setIndirizzoState(tableBrokerState.host);
        if (tableBrokerState?.user != null) setUtenteState(tableBrokerState.user);
    }

    function updatebrokertable() {
        const post_body = {
            serial: serial,
            ...(includeHost && { host: indirizzoState }),
            ...(includeUser && { user: utenteState }),
            ...(includePwd && { pwd: passwordState }),
        };
        updateTable(post_body, '/brokermqttset', setUpdateBrokerTableState)
    }

    function refreshbrokertable() {
        mqttReq(serial, '/brokermqttreq')
    }

    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`GatewayDBTable-Section ${isOpen ? 'open' : ''}`}>
            <button onClick={() => setIsOpen(!isOpen)} style={{ marginBottom: '10px' }}>
                {isOpen ? 'Nascondi Broker' : 'Mostra Broker'}
            </button>
            {isOpen && (
                <table className="GatewayDBTable">
                    <colgroup>
                        <col style={{ width: "15%" }} />
                        <col style={{ width: "40%" }} />
                        <col style={{ width: "40%" }} />
                        <col style={{ width: "5%" }} />
                    </colgroup>
                    <tbody>
                        {/* Table title */}
                        <tr>
                            <th className="tabletitle" colSpan="4">BROKER</th>
                        </tr>

                        {/* Header row: labels for vertical layout */}
                        <tr>
                            <th className="title">Campo</th>
                            <th className="title">Valore attuale</th>
                            <th className="title">Nuovo valore</th>
                            <th className="title">✔</th>
                        </tr>

                        {/* Indirizzo row */}
                        <tr>
                            <td>Indirizzo</td>
                            <td style={{ textAlign: 'center' }}>{tableBrokerState?.host}</td>
                            <td>
                                <input type="text" value={indirizzoState} onChange={handleIndirizzoChange} />
                            </td>
                            <td>
                                <input type="checkbox" checked={includeHost} onChange={() => setIncludeHost(!includeHost)} />
                            </td>
                        </tr>

                        {/* Utente row */}
                        <tr>
                            <td>Utente</td>
                            <td style={{ textAlign: 'center' }}>{tableBrokerState?.user}</td>
                            <td>
                                <input type="text" value={utenteState} onChange={handleUtenteChange} />
                            </td>
                            <td>
                                <input type="checkbox" checked={includeUser} onChange={() => setIncludeUser(!includeUser)} />
                            </td>
                        </tr>

                        {/* Password row */}
                        <tr>
                            <td>Password</td>
                            <td className="noinput"></td>
                            <td>
                                <input type="text" value={passwordState} onChange={handlePasswordChange} />
                            </td>
                            <td>
                                <input type="checkbox" checked={includePwd} onChange={() => setIncludePwd(!includePwd)} />
                            </td>
                        </tr>

                        {/* Ultimo aggiornamento row */}
                        <tr>
                            <td className="timetitle">Ultimo aggiornamento</td>
                            <td style={{ textAlign: "center" }}>{tableBrokerState?.time}</td>
                            <td style={{ textAlign: "center" }}>{updateBrokerTableState}</td>
                        </tr>

                        {/* Buttons row */}
                        <tr>
                            <td colSpan="3" style={{ textAlign: "center" }}>
                                <button onClick={refreshbrokertable} style={{ marginRight: '20px' }}>aggiorna</button>
                                <button onClick={prepareupdatebrokertable} style={{ marginRight: '20px' }}>&gt;</button>
                                <button onClick={updatebrokertable}>invia</button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default BrokerTable;
